<p
  #textElement
  [matTooltip]="isTextTruncated ? text : null"
  [matTooltipDisabled]="!isTextTruncated"
  [class]="addClass + ' ellipsis-text'"
  [ngStyle]="{ '-webkit-line-clamp': lines, 'line-clamp': lines, 'min-height': 1.05 * lines + 'rem' }">
  {{ text }}
</p>
